/* eslint-disable */
const api = {
  getHasPermissionKey: '/saas-auth/permission/hasGroupKeyPermit', // 用户是否用权限的key设置
}

export default api;